import { defineMessages } from 'react-intl'

export default defineMessages({
  stagePending: {
    id: 'components.OrderStage.stage.pending',
    defaultMessage: 'Pending',
  },
  stageReady: {
    id: 'components.OrderStage.stage.ready',
    defaultMessage: 'Ready',
  },
  stageClosed: {
    id: 'components.OrderStage.stage.closed',
    defaultMessage: 'Closed',
  },
  stageInProgress: {
    id: 'components.OrderStage.stage.inProgress',
    defaultMessage: 'In progress',
  },
  stageAmending: {
    id: 'components.OrderStage.stage.amending',
    defaultMessage: 'Revising',
  },
})
